var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 34.34,
    viewBox: "0 0 34.34 34.34",
    width: 34.34,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.17,
    cy: 17.17,
    r: 17.17,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.17,
    cy: 17.17,
    fill: "none",
    r: 16.42
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    transform: "translate(9.127 8.726)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 11.678,
    rx: 1.828,
    width: 3.655,
    x: 0.289,
    y: 5.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.117,
    cy: 2.117,
    rx: 2.117,
    ry: 2.117
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.191-39.88h3.094a.181.181 0 0 1 .18.191s-.012 1.385 0 1.382.046.04.073 0a3.779 3.779 0 0 1 3.319-1.846 2.561 2.561 0 0 1 .653.023 3.52 3.52 0 0 1 3.364 2.337 10.8 10.8 0 0 1 .426 3.253v6.34h-3.665v-6.34s.289-2.453-1.887-2.453-2.093 2.453-2.093 2.453v6.148a.191.191 0 0 1 -.191.191h-3.273a.191.191 0 0 1 -.191-.191v-11.3a.191.191 0 0 1 .191-.188z",
    transform: "translate(6.16 45.68)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon-linkedin.ae866b734a77439def9cf6662bf6f47e.svg";
export { ForwardRef as ReactComponent };